import * as React from 'react';
import { connect } from 'react-redux';
import { photoCaptureIntelligentViewChangeAction } from '../actions';
import { IntelligentPhotoCaptureEstimatorBannerComponent } from '../components';
import { getPhotoCaptureAttachmentInfo, getPhotoCaptureCountryCode, getPhotoCaptureEstimatorConfiguration, getPhotoCaptureEstimatorFileUploadError, getPhotoCaptureFileSizeLimit } from '../selectors';
const mapStateToProps = (state) => ({
    countryCode: getPhotoCaptureCountryCode(state),
    estimatorConfiguration: getPhotoCaptureEstimatorConfiguration(state),
    estimatorFileUploadError: getPhotoCaptureEstimatorFileUploadError(state),
    fileSizeLimit: getPhotoCaptureFileSizeLimit(state),
    photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state)
});
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName));
    }
});
export const IntelligentPhotoCaptureEstimatorBannerComponentWrapper = (props) => {
    return React.createElement(IntelligentPhotoCaptureEstimatorBannerComponent, Object.assign({}, props));
};
export const ConnectedIntelligentPhotoCaptureEstimatorBanner = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCaptureEstimatorBannerComponentWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureEstimatorBanner.js.map